var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddBlock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 0C0.44772 0 0 0.44772 0 1V7C0 7.5523 0.44772 8 1 8H7C7.5523 8 8 7.5523 8 7V1C8 0.44772 7.5523 0 7 0H1ZM1 10C0.44772 10 0 10.4477 0 11V17C0 17.5523 0.44772 18 1 18H7C7.5523 18 8 17.5523 8 17V11C8 10.4477 7.5523 10 7 10H1ZM11 10C10.4477 10 10 10.4477 10 11V17C10 17.5523 10.4477 18 11 18H17C17.5523 18 18 17.5523 18 17V11C18 10.4477 17.5523 10 17 10H11ZM13 8V5H10V3H13V0H15V3H18V5H15V8H13Z",
    fill: "#FAFAFA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddBlock);
export default __webpack_public_path__ + "static/media/Add-Block.194096e414e54bf2d841ceb8307d047d.svg";
export { ForwardRef as ReactComponent };